"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var of_1 = require("rxjs/observable/of");
var idm_document_service_client_js_1 = require("@synisys/idm-document-service-client-js");
var operators_1 = require("rxjs/operators");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var GetEntityImageUrlPipe = /** @class */ (function () {
    function GetEntityImageUrlPipe(deService, documentService) {
        this.deService = deService;
        this.documentService = documentService;
    }
    GetEntityImageUrlPipe.prototype.transform = function (rowItem, imageField, categoryName, mainEntityFieldName) {
        var _this = this;
        var entityId;
        var documentId;
        if (rowItem.hasProperty(imageField)) {
            entityId = rowItem.getInstanceId();
            documentId = rowItem.getProperty(imageField).value;
        }
        else if (rowItem.hasProperty(mainEntityFieldName)) {
            entityId = rowItem.getProperty(mainEntityFieldName).value.getInstanceId();
            documentId = rowItem.getProperty(mainEntityFieldName).value.getProperty(imageField).value;
        }
        if (entityId && documentId) {
            return this.deService.getDocumentToken(categoryName, entityId, imageField)
                .pipe(operators_1.take(1), operators_1.switchMap(function (token) { return _this.documentService.getDocumentUrl(documentId, token, idm_document_service_client_js_1.FileType.ORIGINAL); }));
        }
        else {
            return of_1.of('');
        }
    };
    GetEntityImageUrlPipe = __decorate([
        core_1.Pipe({ name: 'getEntityImageUrl' }),
        __metadata("design:paramtypes", [idm_de_service_client_js_1.DeService, idm_document_service_client_js_1.DocumentService])
    ], GetEntityImageUrlPipe);
    return GetEntityImageUrlPipe;
}());
exports.GetEntityImageUrlPipe = GetEntityImageUrlPipe;
//# sourceMappingURL=entity-image-url.pipe.js.map